export enum WorkingHourUserIdFilter {
  ResourceUser = 0,
  SupervisorOnly = 1,
  LecturerOnly = 2,
  SupervisorAndLecturer = 3,
}
